import type { FC } from 'react';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { useTranslation } from '@/hooks/useTranslation';
import type { MLMachineSummary } from '../type/MLTypes';
import { MachineSourceHint } from '@/features/signals/components/SignalSourceLine';

interface MLMachineSelectProps {
  machines: MLMachineSummary[];
  value: number | null;
  onChange: (id: number) => void;
  disabled: boolean;
}

export const MLMachineSelect: FC<MLMachineSelectProps> = ({
  machines,
  value,
  onChange,
  disabled,
}) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-1.5">
      <div className="flex items-center gap-2">
        <span className="inline-flex h-5 w-5 items-center justify-center rounded-full bg-primary text-2xs font-semibold text-primary-foreground">
          1
        </span>
        <span className="text-sm font-medium text-foreground">
          {t('mlRul.context.step1Label')}
        </span>
      </div>
      <Select
        value={value !== null ? String(value) : ''}
        onValueChange={(v) => onChange(Number(v))}
        disabled={disabled}
      >
        <SelectTrigger className="w-full" data-testid="machine-select-trigger">
          <SelectValue placeholder={t('mlRul.context.step1Placeholder')}>
            {machines.find((m) => m.id === value)?.name}
          </SelectValue>
        </SelectTrigger>
        <SelectContent>
          {machines.map((m) => (
            <SelectItem key={m.id} value={String(m.id)}>
              <span className="flex items-center gap-2">
                <span>{m.name}</span>{' '}
                <MachineSourceHint source={m.kafkaName || null} />
              </span>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};
